import React from 'react';
import { format } from 'date-fns';

interface CustomProps {
  bold?: boolean;
  format: string;
  value?: Date;
  source: string;
  label: string;
}

const Component: React.SFC<CustomProps> = (props) => {
  return props.bold ? (
    <div className="CrudTextField table-tbody__item--bold">
      {props.value ? format(new Date(props.value), props.format) : ''}
    </div>
  ) : (
    <div className="CrudTextField">
      {props.value
        ? props.format
          ? format(new Date(props.value), props.format)
          : props.value
        : ''}
    </div>
  );
};

Component.defaultProps = {
  format: '',
};

export default Component;
